
import React from 'react';
import { BookingProvider } from '../context/BookingContext';
import BookingContainer from '../components/booking/BookingContainer';
import ConnectionStatus from '../components/ConnectionStatus';

const Index = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-medical-50 to-blue-50">
      <main className="py-10">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-10">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground">Book Your Doctor Appointment</h1>
            <p className="mt-3 text-xl text-muted-foreground max-w-2xl mx-auto">
              Find available doctors and schedule an appointment in minutes
            </p>
          </div>

          <ConnectionStatus />

          <div className="bg-white shadow-md rounded-lg p-6">
            <BookingProvider>
              <BookingContainer />
            </BookingProvider>
          </div>
        </div>
      </main>

      <footer className="bg-gray-50 border-t mt-16">
        <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
          <p className="text-center text-sm text-muted-foreground">
            &copy; {new Date().getFullYear()} QuickDoc. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Index;
